/**
 * Convierte un código de país a su nombre en español.
 * @param {string} countryCode - Código ISO del país (ej: 'CL', 'US').
 * @returns {string} Nombre del país en español o el código si no se encuentra.
 */
export function convertCountryCode(countryCode: string): string {
  if (!countryCode || typeof countryCode !== 'string') {
    return countryCode;
  }

  const normalizedCode = countryCode.toUpperCase();
  
  try {
    const displayName = new Intl.DisplayNames(['es'], { type: 'region' }).of(normalizedCode);
    return displayName || countryCode;
  } catch {
    return countryCode;
  }
}

/**
 * Convierte un código de moneda a su nombre en español usando Intl (nativo).
 * @param {string} currencyCode - Código ISO 4217 (ej: 'COP', 'USD').
 * @returns {string} Nombre de la moneda en español o el código si no se encuentra.
 *
 * Ej: convertCurrencyName('COP') -> "peso colombiano"
 */
export function convertCurrencyName(
  currencyCode: string | null | undefined
): string | null | undefined {
  if (!currencyCode || typeof currencyCode !== 'string') {
    return currencyCode;
  }

  const normalizedCode = currencyCode.toUpperCase();

  try {
    const displayName = new Intl.DisplayNames(['es'], { type: 'currency' }).of(normalizedCode);
    if (!displayName) return currencyCode;

    const normalizedDisplayName = displayName.toLowerCase().trim();
    if (normalizedDisplayName === 'moneda desconocida' || normalizedDisplayName === 'unknown currency') {
      return currencyCode;
    }

    return displayName;
  } catch {
    return currencyCode;
  }
}

